/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Настройки чата, выставленные пользователем
 */
export interface GetUserChatSettingsViewDto { 
    /**
     * Признак, что для данного чата не присылать уведомления
     */
    muted: boolean;
}

